import agent from "../../../api/agent";
export const getCompany = (company) => agent.requests.post(`/company/Get`,company);
export const list = (pagerInputModel) =>
  agent.requests.post(`/company/getPagedList`, pagerInputModel);
export const create = (company) => agent.requests.post(`/company/create`, company);
export const update = (company) => agent.requests.post(`company/update`, company);


export const sectorList = (pagerInputModel) =>
  agent.requests.post(`/sector/getlist`, pagerInputModel);
export const subSectorList = (pagerInputModel) =>
  agent.requests.post(`/subsector/getlist`, pagerInputModel);